<template>
    <div>
        <div style="margin: 3px 0px 3px 0px;padding: 3px;background: white">
            <el-row style="display: flex">
                <el-tooltip class="item" effect="dark" content="刷新" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-refresh-right" circle @click="reflash" type="success"></el-button>
                </el-tooltip>
            </el-row>
            <el-row>
                <el-input v-model="queryKey" type="text"
                          @click.native.prevent="getView"
                          @keyup.enter.native="getView"
                          suffix-icon="el-icon-search"
                          size="medium" style="width:200px;margin-left: 8px"></el-input>
                <el-tooltip class="item" effect="dark" content="查询" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-search" circle @click="getView"></el-button>
                </el-tooltip>
            </el-row>
        </div>
        <el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
        >
            <el-table-column type="selection" v-if="false"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productname" label="品名"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productmodel" label="型号"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productspecs" label="规格"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productimg1" label="产品图片1">
                <template scope="scope">
                    <!--<img :src="expurl(scope.row.productimg1)">-->
                    <el-image
                            style="width: 100px; height: 100px"
                            :src="expurl(scope.row.productimg1)">
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="productimg2" label="产品图片2">
                <template scope="scope">
                    <!--<img :src="expurl(scope.row.productimg1)">-->
                    <el-image
                            style="width: 100px; height: 100px"
                            :src="expurl(scope.row.productimg2)">
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="productimg3" label="产品图片3">
                <template scope="scope">
                    <!--<img :src="expurl(scope.row.productimg1)">-->
                    <el-image
                            style="width: 100px; height: 100px"
                            :src="expurl(scope.row.productimg3)">
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="productimg4" label="产品图片4">
                <template scope="scope">
                    <!--<img :src="expurl(scope.row.productimg1)">-->
                    <el-image
                            style="width: 100px; height: 100px"
                            :src="expurl(scope.row.productimg4)">
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="retailprice" label="零售价" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="provincialprice" label="省代价格" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="cityprice" label="市代价格" align="right"></el-table-column>
            <el-table-column fixed="right" label="操作" width="140">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="addPurchase(scope.row, 0)" type="text" size="mini">加购</el-button>
                    <el-button @click.native.prevent="addPurchase(scope.row, 1)" type="text" size="mini" v-if="isShowPoints && (rolelv!=3)">积分兑换</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-row>
            <el-col :span="18">
                <el-pagination
                        style="margin-top: 1em"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="SelectIndexs"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="100"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import Common from '@/components/Common';
    import axios from 'axios';

    export default {
        data() {
            return {
                dataSet: [], // 主表数据
                dataDetail: {},
                isVisible: false, // 查询列表是否显示
                userData: [], // 用户信息
                user: "",
                rolelv: "",
                usercode: "",
                pageIndex: 1, // 当前页
                pageSize: 50, // 当前页数据量
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                tableHeight: window.innerHeight - 250, // 主表高度
                queryKey: "",
                SortList: [],
                ScreenList: [],
                isShowPoints: false
            };
        },
        mounted: function () {
            let that = this
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username
            that.usercode = that.userData.Login_Code
            that.rolelv = that.userData.rolelv
            that.isShowPoints = that.userData.isShowPoints == 0 ? false:true
            that.getView()
        },
        methods: {
            handleSizeChange(val) {
                this.pageSize = val;
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val
                this.SelectIndexs = val;
                this.getView();
            },
            reflash() {
                let that = this
                that.queryKey = ""
                that.getView()
            },
            getView() {
                let that = this
                that.loading = true
                let parm = {
                    PageSize: that.pageSize,
                    PageIndex: that.pageIndex,
                    QueryKey: that.queryKey,
                    iid: "",
                    SortList: that.SortList,
                    ScreenList: that.ScreenList
                };
                that.$http.urlpost('/SysProduct/View', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            expurl(value){
                return Common.Url+'uploads/'+value
            },
            addPurchase(value,type){
                let that = this
                that.$router.push({
                    path: '/dordermanage',
                    // name: 'mallList',
                    query: {
                        data:value.iid,
                        isshow: 'JG',
                        exchange: type
                    }
                })
                /*that.$router.push({ path: '/dordermanage' });*/
            }
        }
    };
</script>

<style scoped lang="less">
</style>
